module.exports = __webpack_public_path__ + "static/fonts/iconfont.8fe6b72.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/iconfont.woff2?t=1741155911033
// module id = H+8B
// module chunks = 141